<template>
  <v-btn
    @click="fbqContact"
    :class="[!sm ? 'rounded-xl' : '']"
    :href="whatslink"
    :fab="sm"
    :large="!sm"
    target="_blank"
    color="#00E676"
    dark
    fixed
    bottom
    right
  >
    <v-icon :left="!sm" :size="!sm ? 24 : ''">fab fa-whatsapp</v-icon>
    <span v-if="!sm" class="whatsapp-button-text">Whatsapp</span>
  </v-btn>
</template>

<script>
export default {
  props: {
    tel: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      default: "",
    },
  },
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    whatslink() {
      return this.informations.whatsapp_button
        ? this.informations.whatsapp_button
        : `https://wa.me/55${this.informations.whatsapp.replace(
            /[^0-9]/g,
            ""
          )}`;
    },
    sm() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  methods: {
    fbqContact: () =>
      window.fbq("track", "Contact") ||
      window.console.log("Facebook Pixel: Track -> Contact"),
  },
};
</script>

<style>
.test {
  position: absolute;
  right: 0;
  bottom: 0;
}
.whatsapp-button-text {
  font-family: Helvetica, Arial, sans-serif;
  font-weight: bold;
  font-size: 17px;
  text-transform: none;
}
</style>
